/**
 * WeatherMap自定义配置
 *
 * @requires WeatherMap
 * @author Rexer Wang
 */

~ function(WeatherMap) {
    /**
     * 根目录
     * @type {string}
     */
    const WM_ROOT = 'https://www.moodsmap.com/typhoon/static/WeatherMap'

    /**
     * 图片资源地址
     * @type {string}
     */
    WeatherMap.ImgPath = WM_ROOT + '/theme/images/'

    /**
     * @Override
     */
    WeatherMap._getScriptLocation = function() {
        return WM_ROOT + '/libs/'
    }

}(WeatherMap)


// WEBPACK FOOTER //
// ./src/map/config.js